import React from 'react';
import './PauseMenu.css';

function PauseMenu({
    gameName = 'Game',
    score = 0,
    onResume,
    onRestart,
    onQuit,
    stats = {}
}) {
    return (
        <div className="pause-overlay">
            <div className="pause-modal">
                <div className="pause-header">
                    <span className="pause-icon">⏸️</span>
                    <h2>Game Paused</h2>
                </div>

                <div className="pause-game-info">
                    <span className="pause-game-name">{gameName}</span>
                    <span className="pause-score">Score: {score.toLocaleString()}</span>
                </div>

                {Object.keys(stats).length > 0 && (
                    <div className="pause-stats">
                        {stats.accuracy !== undefined && (
                            <div className="stat-item">
                                <span className="stat-icon">🎯</span>
                                <span className="stat-label">Accuracy</span>
                                <span className="stat-value">{stats.accuracy}%</span>
                            </div>
                        )}
                        {stats.matches !== undefined && (
                            <div className="stat-item">
                                <span className="stat-icon">✨</span>
                                <span className="stat-label">Matches</span>
                                <span className="stat-value">{stats.matches}</span>
                            </div>
                        )}
                        {stats.combo !== undefined && (
                            <div className="stat-item">
                                <span className="stat-icon">🔥</span>
                                <span className="stat-label">Best Combo</span>
                                <span className="stat-value">{stats.combo}x</span>
                            </div>
                        )}
                        {stats.timeElapsed !== undefined && (
                            <div className="stat-item">
                                <span className="stat-icon">⏱️</span>
                                <span className="stat-label">Time</span>
                                <span className="stat-value">{stats.timeElapsed}s</span>
                            </div>
                        )}
                    </div>
                )}

                <div className="pause-actions">
                    <button className="pause-btn resume" onClick={onResume}>
                        <span className="btn-icon">▶️</span>
                        <span>Resume</span>
                    </button>
                    <button className="pause-btn restart" onClick={onRestart}>
                        <span className="btn-icon">🔄</span>
                        <span>Restart</span>
                    </button>
                    <button className="pause-btn quit" onClick={onQuit}>
                        <span className="btn-icon">🚪</span>
                        <span>Quit Game</span>
                    </button>
                </div>

                <p className="pause-tip">
                    💡 Tip: Take a break and come back refreshed!
                </p>
            </div>
        </div>
    );
}

export default PauseMenu;
